import { gsap } from "gsap/dist/gsap";

const SEL = {
  root: ".js-home-banner",
  title: ".js-home-banner__title",
  galleryItem: ".js-home-banner__gallery-item",
  subtitle: ".js-home-banner__subtitle",
  logo: ".js-home-banner__logo",
};

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(SEL.root);
  if (!root) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const title = root.querySelector(SEL.title);
  const galleryItems = root.querySelectorAll(SEL.galleryItem);
  const subtitle = root.querySelector(SEL.subtitle);
  const logos = root.querySelectorAll(SEL.logo);

  const tl = gsap.timeline({
    defaults: { ease: "power2.out" },
  });

  if (title) {
    tl.from(
      title,
      { autoAlpha: 0, y: 32, duration: 0.75 },
      0,
    );
  }

  if (galleryItems.length) {
    tl.from(
      galleryItems,
      {
        autoAlpha: 0,
        y: 24,
        duration: 0.55,
        stagger: 0.07,
      },
      title ? "-=0.4" : 0,
    );
  }

  if (subtitle) {
    tl.from(
      subtitle,
      { autoAlpha: 0, y: 28, duration: 0.65 },
      galleryItems.length ? "-=0.35" : title ? "-=0.35" : 0,
    );
  }

  if (logos.length) {
    tl.from(
      logos,
      {
        autoAlpha: 0,
        y: 18,
        scale: 0.94,
        duration: 0.48,
        stagger: { each: 0.06, from: "start" },
      },
      "-=0.38",
    );
  }
});
